export function Divider() {
  return (
    <div className="bg-sbeige h-[2px] w-[30px] md:h-[4px] md:w-[60px]"></div>
  );
}
